<template>
  <div class="confection-tile">
    <div class="confection-tile__top">
      <div class="confection-tile__bestseller" v-if="isBestseller">
        <span class="confection-tile__bestseller-text">
          Bestseller!
        </span>
      </div>
      <img
        class="confection-tile__image img-responsive"
        alt="Podgląd produktu"
        :src="imageUrl"
      />
    </div>
    <div class="confection-tile__content">
      <div class="confection-tile__info">
        <span class="confection-tile__name">{{ item.name }}</span>
        <icon
          v-if="tooltipMessage"
          class="confection-tile__icon"
          v-tooltip="tooltipMessage"
          icon="info"
        />
        <div v-if="price > 0" class="confection-tile__price">
          <span>{{ price.toFixed(2) }} zł</span>
          <br />
          <span>sztuka</span>
        </div>
        <div v-else class="confection-tile__price">
          <span>gratis!</span>
        </div>
      </div>
      <slot name="button">
        <button
          type="button"
          class="btn btn-outline-primary confection-tile__add-to-cart"
          @click="addToCart"
          :disabled="inCart"
        >
          {{ inCart ? "Dodano do zamówienia!" : "Dodaj do zamówienia" }}
        </button>
      </slot>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import { NDEConfectionTooltips } from '@/utils/confection/tooltips';
import { NDE_CONFECTION } from '@/utils/categoryUtils';

export default {
  name: 'ConfectionTile',
  components: {
    Icon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    inCart: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tooltipMessage() {
      return NDEConfectionTooltips[this.item.product_category] || '';
    },
    price() {
      return this.item.price ? parseFloat(this.item.price) : 0;
    },
    isBestseller() {
      return this.item.product_category === NDE_CONFECTION.ETUI;
    },
  },
  methods: {
    addToCart() {
      this.$emit('add-to-cart');
    },
  },
};
</script>
